<template>
    <div class="flex gap-8 flex-col">
        <EventCalendarFilterLoader />
        <div class="flex flex-col gap-10">
            <TimelineContentLoader
                v-for="index in 3"
                :key="index"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
    import EventCalendarFilterLoader from '~/components/eventCalendar/EventCalendarFilterLoader.vue';
    import TimelineContentLoader from '~/components/timeline/TimelineContentLoader.vue';
</script>
